import styled from "styled-components";

export const ManageRevenueSplitTableWrapper = styled.div`
  .width-200 {
    width: 200px;
  }

  .disabled {
    opacity: 0.5;
  }
`;
